import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, asyncToGenerator as _asyncToGenerator, classCallCheck as _classCallCheck, callSuper as _callSuper, regeneratorRuntime as _regeneratorRuntime, createForOfIteratorHelper as _createForOfIteratorHelper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import isEqual from 'lodash/isEqual';
import React, { Component } from 'react';
import { i18n } from '../../../i18n/translate.js';
import { hasCapability } from '../../../utils/AccessControlUtil.js';
import { storage } from '../../../utils/Storage.js';
import { ErrorPage } from '../../ErrorPage/index.js';
import { ChartExportModal } from '../ui-components/chart-export-modal.js';
import { ChartToolbar } from '../ui-components/chart-toolbar.js';
import { format } from '../../../utils/dateHelpers.js';
import { JsonApiRecordDecorator } from '../../../json-api/JsonApiRecordDecorator.js';
import { toggleElementFullscreen } from '../../../utils/toggleElementFullscreen.js';

var TableauChart = /*#__PURE__*/function (_Component) {
  function TableauChart(props) {
    var _this;

    _classCallCheck(this, TableauChart);

    _this = _callSuper(this, TableauChart, [props]);

    _defineProperty(_this, "exportImage", function () {
      _this.viz.showExportImageDialog();
    });

    _defineProperty(_this, "clearIntervals", function () {
      clearInterval(_this.initialPolling);
      delete _this.initialPolling;
      clearInterval(_this.longPolling);
      delete _this.longPolling;
    });

    _defineProperty(_this, "exportCrossTab", function () {
      try {
        _this.viz.showExportCrossTabDialog(_this.props.chart.csv_view);
      } catch (err) {
        var message = err.get_message ? err.get_message() : err;

        _this.props.onError("Unable to download, please contact an admin (".concat(message, ")"));
      }
    });

    _defineProperty(_this, "exportPDF", function () {
      _this.viz.showExportPDFDialog();
    });

    _defineProperty(_this, "refreshData", function () {
      _this.viz.refreshDataAsync();
    });

    _defineProperty(_this, "revertAll", function () {
      if (_this.workbook) {
        _this.workbook.revertAllAsync();
      } else if (_this.viz) {
        var _this$workbook;

        _this.workbook = _this.viz.getWorkbook();
        (_this$workbook = _this.workbook) === null || _this$workbook === void 0 || _this$workbook.revertAllAsync(); // eslint-disable-line no-unused-expressions
      } else {
        throw new Error('No workbook or viz found');
      }
    });

    _defineProperty(_this, "getFilters", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(sheets) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(sheets) {
                    var _iterator, _step, sheet, sheetFilters;

                    return _regeneratorRuntime().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _iterator = _createForOfIteratorHelper(sheets);
                            _context.prev = 1;

                            _iterator.s();

                          case 3:
                            if ((_step = _iterator.n()).done) {
                              _context.next = 13;
                              break;
                            }

                            sheet = _step.value;
                            _context.next = 7;
                            return sheet.getFiltersAsync();

                          case 7:
                            sheetFilters = _context.sent;
                            _context.next = 10;
                            return sheetFilters.reduce(function (acc, filter) {
                              if (filter && filter.getFilterType() === 'categorical' && !filter.getIsAllSelected() && !['Measure Names', 'Date Range Filter'].includes(filter.getFieldName()) && filter.getAppliedValues()) {
                                acc[filter.getFieldName()] = filter.getAppliedValues().map(function (val) {
                                  var _val$formattedValue;

                                  return (_val$formattedValue = val.formattedValue) === null || _val$formattedValue === void 0 ? void 0 : _val$formattedValue.replaceAll(',', '\\,');
                                }).join(',');
                              }

                              return acc;
                            }, {});

                          case 10:
                            return _context.abrupt("return", _context.sent);

                          case 11:
                            _context.next = 3;
                            break;

                          case 13:
                            _context.next = 18;
                            break;

                          case 15:
                            _context.prev = 15;
                            _context.t0 = _context["catch"](1);

                            _iterator.e(_context.t0);

                          case 18:
                            _context.prev = 18;

                            _iterator.f();

                            return _context.finish(18);

                          case 21:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, null, [[1, 15, 18, 21]]);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_this, "getParameters", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(sheets) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(workbook) {
                    var parameters;
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return workbook.getParametersAsync();

                          case 2:
                            parameters = _context3.sent;
                            _context3.next = 5;
                            return parameters.reduce(function (acc, param) {
                              if (param && param.getDataType() === 'date') {
                                acc[param.getName().replace(/\s/g, '')] = format(param.getCurrentValue().formattedValue, 'yyyy-MM-dd');
                              }

                              return acc;
                            }, {});

                          case 5:
                            return _context3.abrupt("return", _context3.sent);

                          case 6:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4) {
                    return _ref4.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_this, "exportData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var _this$props$chart, csv_view, csv_workbook, sheets, formFilters, formedFilters, formParameters, formedParameters, newDataExport;

      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$props$chart = _this.props.chart, csv_view = _this$props$chart.csv_view, csv_workbook = _this$props$chart.csv_workbook;
              sheets = _this.viz.getWorkbook().getActiveSheet().getWorksheets();
              _context5.next = 4;
              return _this.getFilters(sheets);

            case 4:
              formFilters = _context5.sent;
              _context5.next = 7;
              return formFilters(sheets);

            case 7:
              formedFilters = _context5.sent;
              _context5.next = 10;
              return _this.getParameters(_this.workbook);

            case 10:
              formParameters = _context5.sent;
              _context5.next = 13;
              return formParameters(_this.workbook);

            case 13:
              formedParameters = _context5.sent;
              newDataExport = Object.assign(new JsonApiRecordDecorator(), {
                type: 'data_exports',
                data_type: 'Datafi::Exports::Tableau',
                name: _this.workbook.getName(),
                filters: {
                  filters: Object.assign({}, formedFilters, formedParameters),
                  view_name: String(csv_view),
                  workbook_name: String(csv_workbook)
                }
              });

              _this.setState({
                showExportModal: true,
                pollingExport: true
              });

              _this.props.createDataExport(newDataExport);

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    })));

    _defineProperty(_this, "closeExportModal", function () {
      _this.clearIntervals();

      _this.setState({
        showExportModal: false,
        pollingExport: false
      });
    });

    _defineProperty(_this, "toggleFullscreen", function () {
      var elem = _this.chartDiv.current;
      toggleElementFullscreen(elem);
    });

    _defineProperty(_this, "suppressLoadingClass", function () {
      storage.setItem('suppressLoadingClass', 'true');
    });

    _defineProperty(_this, "selectDownload", function (downloadType) {
      var downloadAction;

      switch (downloadType) {
        case 'workbook':
          downloadAction = _this.exportCrossTab;
          break;

        case 'tableau_api':
          downloadAction = _this.exportData;
          break;

        case 'image':
          downloadAction = _this.exportImage;
          break;

        case 'pdf':
          downloadAction = _this.exportPDF;
          break;
      }

      downloadAction();
    });

    _this.state = {
      pollingExport: false,
      showExportModal: false
    };
    _this.chartDiv = /*#__PURE__*/React.createRef();
    return _this;
  }

  _inherits(TableauChart, _Component);

  return _createClass(TableauChart, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$chartDiv,
          _this$props$chart2,
          _this2 = this;

      var filters = this.props.filters;
      var containerDiv = (_this$chartDiv = this.chartDiv) === null || _this$chartDiv === void 0 ? void 0 : _this$chartDiv.current;
      var validFilters = filters ? Object.fromEntries(Object.entries(filters).filter(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2);

        _ref7[0];
        var val = _ref7[1];
        return val !== null && val !== undefined;
      })) : {};

      var options = _objectSpread2({
        hideToolbar: !((_this$props$chart2 = this.props.chart) !== null && _this$props$chart2 !== void 0 && _this$props$chart2.show_toolbar),
        onFirstInteractive: function onFirstInteractive() {
          _this2.workbook = _this2.viz.getWorkbook();
          _this2.dash = _this2.viz.getWorkbook().getActiveSheet();
        }
      }, validFilters);

      try {
        if (containerDiv) {
          this.viz = new this.props.tableau.Viz(containerDiv, this.props.chartSourceUrl, options);
        } else {
          this.viz = null;
        }
      } catch (e) {
        this.viz = null;
      }

      if (!this.viz) {
        this.setState({
          error: i18n.t('Unable to connect to tableau.')
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(prevProps) {
        var _this3 = this;

        var _this$props$currentEn, _this$props$currentEn2, _this$props$currentEn3, _this$props$currentEn4;

        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this.dash && this.props.filters && !isEqual(prevProps.filters, this.props.filters)) {
                  // Apply all passed filters with valid values for each worksheet
                  Object.keys(this.props.filters).filter(function (key) {
                    var _this3$props$filters, _this3$props$filters2;

                    return ((_this3$props$filters = _this3.props.filters) === null || _this3$props$filters === void 0 ? void 0 : _this3$props$filters[key]) !== null && ((_this3$props$filters2 = _this3.props.filters) === null || _this3$props$filters2 === void 0 ? void 0 : _this3$props$filters2[key]) !== undefined;
                  }).forEach(function (key) {
                    _this3.dash.getWorksheets().forEach(function (worksheet) {
                      var _this3$props$filters3;

                      worksheet.applyFilterAsync(key, (_this3$props$filters3 = _this3.props.filters) === null || _this3$props$filters3 === void 0 ? void 0 : _this3$props$filters3[key], _this3.props.tableau.FilterUpdateType.REPLACE);
                    });
                  });
                }

                if (!(this.props.currentEntity && prevProps.currentEntity !== this.props.currentEntity)) {
                  _context6.next = 11;
                  break;
                }

                if (['completed', 'error', 'completed_without_download'].includes((_this$props$currentEn = this.props.currentEntity) === null || _this$props$currentEn === void 0 ? void 0 : _this$props$currentEn.status)) {
                  this.setState({
                    pollingExport: false
                  }, this.clearIntervals);
                }

                if (!(prevProps.currentEntity && !isEqual(prevProps.currentEntity.id, (_this$props$currentEn2 = this.props.currentEntity) === null || _this$props$currentEn2 === void 0 ? void 0 : _this$props$currentEn2.id) && (_this$props$currentEn3 = this.props.currentEntity) !== null && _this$props$currentEn3 !== void 0 && _this$props$currentEn3.id && this.state.pollingExport)) {
                  _context6.next = 10;
                  break;
                }

                _context6.next = 6;
                return this.props.shortDataExportPoll(this.props.currentEntity.id);

              case 6:
                this.initialPolling = _context6.sent;
                _context6.next = 9;
                return this.props.longDataExportPoll(this.props.currentEntity.id);

              case 9:
                this.longPolling = _context6.sent;

              case 10:
                if (((_this$props$currentEn4 = this.props.currentEntity) === null || _this$props$currentEn4 === void 0 ? void 0 : _this$props$currentEn4.status) === 'error' || this.props.errorMessage) {
                  this.setState({
                    pollingExport: false,
                    showExportModal: false
                  });
                }

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function componentDidUpdate(_x5) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearIntervals();
    }
  }, {
    key: "toolbarButtons",
    get: function get() {
      return [{
        onClick: this.revertAll,
        icon: 'xmark',
        label: i18n.t('Clear Filters')
      }, {
        onClick: this.refreshData,
        icon: 'undo',
        label: i18n.t('Refresh Data'),
        hide: this.props.chart.disable_refresh
      }, {
        onClick: this.toggleFullscreen,
        icon: 'expand',
        label: i18n.t('Full Screen')
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var pollingExport = this.state.pollingExport;

      var _this$props = this.props,
          capabilities = _this$props.capabilities,
          export_availability = _this$props.chart.export_availability,
          _this$props$currentEn5 = _this$props.currentEntity,
          _this$props$currentEn6 = _this$props$currentEn5 === void 0 ? {
        download_url: null
      } : _this$props$currentEn5,
          download_url = _this$props$currentEn6.download_url,
          padding = _this$props.padding,
          _this$props$showRepor = _this$props.showReportToolbar,
          showReportToolbar = _this$props$showRepor === void 0 ? false : _this$props$showRepor,
          _this$props$toolbarTy = _this$props.toolbarType,
          toolbarType = _this$props$toolbarTy === void 0 ? 'standard' : _this$props$toolbarTy;

      var downloadModalTitle = download_url ? i18n.t('Report Ready') : i18n.t('Generating your report');
      var style = padding ? {
        padding: padding
      } : undefined; // Check is only for Impact reports, normal report always shows download buttons.

      var canDownloadReport = capabilities ? hasCapability('Capabilities::FileDownloads', capabilities) : true;

      if (this.state.error) {
        return /*#__PURE__*/React.createElement(ErrorPage, {
          renderAsLegacy: true,
          errors: [this.state.error],
          title: i18n.t('Something Went Wrong.')
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "chart",
        ref: this.chartDiv
      }, /*#__PURE__*/React.createElement(ChartToolbar, {
        buttons: this.toolbarButtons,
        canDownloadReport: canDownloadReport,
        exportAvailability: export_availability,
        onSelectDownload: this.selectDownload,
        pollingExport: pollingExport,
        show: showReportToolbar,
        style: style,
        toolbarType: toolbarType
      }), /*#__PURE__*/React.createElement(ChartExportModal, {
        downloadUrl: download_url,
        onClose: this.closeExportModal,
        onDownloadClicked: this.suppressLoadingClass,
        show: this.state.showExportModal,
        title: downloadModalTitle
      }));
    }
  }]);
}(Component);

_defineProperty(TableauChart, "defaultProps", {
  filters: {},
  showReportToolbar: true
});

TableauChart.displayName = "TableauChart";
export { TableauChart };